import { ReactNode } from "react";

export enum ManageLoanActions {
    AutoManage,
    ManualManage,
    AdjustDebt,
    AdjustCollateral,
    ManageLiquidity,
    ClosePosition,
    UpdateTerms,
    AdjustLeverageDialog,
    ToggleLoanType,
    Rollover,
    RefinanceProtection
}

export enum ManualManageSubActions {
    IncreasePrincipal,
    DecreasePrincipal,
    TopUpCollateral,
    WithdrawCollateral,
    ManualIncreaseLeverage,
    ManualDecreaseLeverage,
    AutoLeverageDialog,
    ManualLeverageDialog
}

export enum LoanManagementActionCategory {
    Leverage,
    DebtAndCollateral,
    Miscellaneous
}

export type LoanAction = {
    buttonDropdownText: string;
    buttonSelectedText: string;
    dialogHeaderLabel?: string;
    icon: ReactNode;
    action: ManageLoanActions;
    hide?: boolean;
    disabled?: boolean;
    isDrawer?: boolean;
    component: ReactNode;
    onClick?: () => void | Promise<void>;
};

export type GroupedLoanActions = {
    [LoanManagementActionCategory.Leverage]: LoanAction[];
    [LoanManagementActionCategory.DebtAndCollateral]: LoanAction[];
    [LoanManagementActionCategory.Miscellaneous]: LoanAction[];
};
